import { Plugin } from 'ckeditor5/src/core';
import { FileDialogButtonView } from 'ckeditor5/src/upload';
import icon from '../theme/icons/paperclip.svg';
import '../theme/file.css';
export default class FileUploadUI extends Plugin {
    static get pluginName() {
        return 'FileUploadUI';
    }
    init() {
        const t = this.editor.t;
        const componentCreator = (locale) => {
            const command = this.editor.commands.get('fileUpload');
            const view = new FileDialogButtonView(locale);
            view.set({
                allowMultipleFiles: false
            });
            view.buttonView.set({
                label: t('Insert file'),
                icon,
                tooltip: true,
                class: 'ck-toolbar-file-upload-icon'
            });
            view.buttonView.bind('isEnabled').to(command);
            view.on('done', (evt, files) => {
                const filesToUpload = Array.from(files);
                this.editor.execute('fileUpload', filesToUpload);
                this.editor.editing.view.focus();
            });
            return view;
        };
        this.editor.ui.componentFactory.add('fileUpload', componentCreator);
    }
}
